export default __webpack_public_path__ + "static/media/egiro_step_3.3623601d.png";